import { render, staticRenderFns } from "./sensitive.vue?vue&type=template&id=653eb6f8"
import script from "./sensitive.vue?vue&type=script&lang=js"
export * from "./sensitive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports